<template>
  <v-card>
    <v-card-text>
      <amplify-authenticator
        v-if="!authenticated"
        :auth-config="authConfig"
        class="center-form"
      ></amplify-authenticator>
      <amplify-sign-up
        v-else-if="adminUsers.includes(user.username)"
      ></amplify-sign-up>
      <div class="text-lg-center">
        <div v-if="userAdded">
          <v-icon color="success">check_outline</v-icon>User successfully added
        </div>
        <v-btn small v-else @click="$emit('close-auth')" flat color="info"
          >close</v-btn
        >
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { components } from "aws-amplify-vue";

export default {
  name: "AmplifyAuth",

  props: {
    adminUsers: Array,
  },

  components: {
    ...components,
  },

  data() {
    return {
      authConfig: {
        signInConfig: {
          header: "Log in to riparian.info",
        },
        signUpConfig: {
          header: "Only administrators may create new accounts",
          signUpFields: [],
        },
      },
    };
  },

  computed: {
    authenticated() {
      return this.$store.state.settings.authenticated;
    },
    user() {
      return this.$store.state.settings.user;
    },
    userAdded() {
      return this.$store.state.settings.userAdded;
    },
  },
};
</script>

<style scoped>
.center-form {
  width: 100%;
}
</style>
